const ContainerCard = ({ width }) => {
  return (
    <div style={{ width: width }} className="absolute top-[-248px] left-[0px] w-[1360px] h-[1360px] overflow-hidden text-center text-174xl text-light-white font-hero-text">
      <div className="absolute top-[277px] left-[0px] w-[1366px] h-[692px] overflow-hidden">
        <div className="absolute top-[-277px] left-[0px] w-[1366px] h-[967px]">
          <div className="absolute top-[0px] left-[0px] w-[1366px] h-[967px] overflow-hidden flex flex-row items-start justify-start">
            <img
              className="relative w-[1359.99px] h-[1360px] opacity-[0.3]"
              alt=""
              src="/vector.svg"
            />
          </div>
        </div>
        <div className="absolute h-[43.77%] w-[52.05%] top-[20.87%] left-[23.72%] tracking-[0.5px] leading-[166px] uppercase flex items-center justify-center">
          CASh
        </div>
        <img
          className="absolute h-[65.47%] w-[27.09%] top-[20.29%] right-[36.68%] bottom-[14.24%] left-[36.24%] max-w-full overflow-hidden max-h-full object-cover"
          alt=""
          id="introPhone1"
          src="/introphone-1@2x.png"
        />
        <p
          className="[border:none] bg-[transparent] font-hero-text text-174xl absolute h-[43.77%] w-[52.05%] top-[31.45%] left-[23.72%] tracking-[0.5px] leading-[166px] uppercase text-light-white text-center flex items-center"
          placeholder={`
APP`}
        >
          <span className="[line-break:anywhere] w-full">
            <p className="m-0">&nbsp;</p>
            <p className="m-0">APP</p>
          </span>
        </p>
        <img
          className="absolute h-[10.58%] w-[5.42%] top-[6.96%] right-[77.89%] bottom-[82.46%] left-[16.69%] max-w-full overflow-hidden max-h-full object-cover"
          alt=""
          id="introcube"
          src="/introcube-1@2x.png"
        />
        <img
          className="absolute h-[25.5%] w-[13.76%] top-[64.64%] right-[71.01%] bottom-[9.86%] left-[15.23%] max-w-full overflow-hidden max-h-full object-cover"
          alt=""
          id="introcube1"
          src="/introcubes-1@2x.png"
        />
        <img
          className="absolute h-[47.67%] w-[21.08%] top-[64.64%] right-[18.59%] bottom-[-12.31%] left-[60.32%] max-w-full overflow-hidden max-h-full object-cover"
          alt=""
          src="/intropillar-1@2x.png"
        />
        <img
          className="absolute h-[37.7%] w-[14.64%] top-[6.96%] right-[10.54%] bottom-[55.34%] left-[74.82%] max-w-full overflow-hidden max-h-full object-cover"
          alt=""
          id="introStair1"
          src="/introstairs-1@2x.png"
        />
      </div>
    </div>
  );
};

export default ContainerCard;
